
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

// Definición de defaults

export const defaultAgregarApiKey: AgregarApiKeyResponse = {
    ...defaultHttpResponse,
}

export const defaultActualizarApiKey: ActualizarApiKeyResponse = {
    ...defaultHttpResponse,
}

// Creación de interfaces

export interface ApiKeyProps {
    id?:             string;
    idApiKeys?:      number;
    descripcion?:    string;
    apiKey?:         string;
    fechaCreacion?:  Date;
    activo?:         boolean;
    dominios?:       ApiKeyDominioProps[];
}

export interface ApiKeyDominioProps{
    id:             string;
    dominio:        string;
    activo:         boolean;
}

export interface ActualizarApiKeyEstatusParams {
    id:             string;
    activar:        boolean;
}

export interface AgregarApiKeyParams {
    descripcion:    string;
    dominios:       ApiKeyDominioProps[];
}

export interface AgregarApiKeyResponse extends HttpResponse, ApiKeyProps {}

export interface ActualizarApiKeyParams{
    id:             string; 
    descripcion:    string;
    dominios:       ApiKeyDominioProps[];
}

export interface ActualizarApiKeyResponse extends HttpResponse, ApiKeyProps {}